import React, { Component } from 'react'
import { Spinner } from '../Loaders/Loaders'
import {
  GET_AVAILABLE_AMENDMENTS,
  GET_AVAILABLE_ORDER_FILINGS,
  GET_APP_SETTING_BY_NAME,
} from '../../requests'
import { history } from '../../store'
import { DummyFormBlock } from 'components/Forms/Forms'
import ReactMarkdown from 'components/Markdown/Markdown'

export default class AmendmentLauncher extends Component {
  constructor() {
    super()
    this.state = { amendments: null, showAmendmentMessage: false, amendmentMessageText: '' }
  }
  componentDidMount = () => {
    if (this.props.getAvailableAmendments) {
      this.props.getAvailableAmendments().then((amendments) => this.setState({ amendments }))
    } else {
      this.getAvailableAmendments()
    }

    GET_APP_SETTING_BY_NAME(
      'FileAmendmentPopupMessage',
      (setting) => {
        this.setState({ amendmentMessageText: setting.VALUE })
      },
      (err) => {
        console.error(err)
      }
    )

    GET_APP_SETTING_BY_NAME(
      'FileAmendmentPopupMessageOnOff',
      (setting) => {
        const json = JSON.parse(setting.VALUE)
        json && this.setState({ showAmendmentMessage: !!json[this.props.category] })
      },
      (err) => {
        console.error(err)
      }
    )
  }

  getAvailableAmendments = () => {
    if (this.props.isOrderFiling === true) {
      GET_AVAILABLE_ORDER_FILINGS(
        this.props.sourceId,
        this.props.category,
        (amendments) => {
          this.setState({ amendments })
        },
        (err) => {
          console.error(err)
        }
      )
    } else {
      GET_AVAILABLE_AMENDMENTS(
        this.props.filingNum,
        this.props.category,
        (amendments) => {
          this.setState({ amendments })
        },
        (err) => {
          console.error(err)
        }
      )
    }
  }
  openOrderFiling = (formDefinitionId, category, sourceId) => {
    history.push(`/forms/new/${formDefinitionId}?category=${category}&sourceId=${sourceId}`)
  }
  openAmendment = (FORM_DEFINITION_ID) => {
    if (this.props.openAmendment) {
      this.props.openAmendment(FORM_DEFINITION_ID)
    } else {
      history.push(`/amend/${FORM_DEFINITION_ID}/${this.props.filingNum}`)
    }
  }

  render() {
    return (
      <div className="amendment-launcher">
        {this.state.amendments ? (
          <div className="amendments">
            {this.state.amendments.length === 0 && (
              <p className="empty">
                There are no {this.props.isOrderFiling === true ? 'orders' : 'amendments'} available
                for this record.
              </p>
            )}
            {this.state.amendments.map((amd) => (
              <React.Fragment key={`${amd.AMENDMENT_TYPE_ID}${amd.FORM_DEFINITION_ID}`}>
                <button
                  className={'form-block-card'}
                  disabled={amd.DISABLED || amd.NOT_AVAILABLE_ONLINE_YN}
                  title={amd.TITLE}
                  onClick={() => {
                    if (this.props.isOrderFiling) {
                      this.openOrderFiling(
                        amd.FORM_DEFINITION_ID,
                        this.props.category,
                        this.props.sourceId
                      )
                    } else {
                      this.openAmendment(amd.FORM_DEFINITION_ID)
                    }
                  }}
                >
                  <DummyFormBlock label={amd.TITLE} />
                </button>
                <ReactMarkdown className="markdown description" source={amd.DESCR || ''} />
                {(amd.EXPIRATION_DATE || amd.EXPIRATION_MESSAGE) && (
                  <ReactMarkdown
                    className={`markdown description ${amd.MESSAGE_COLOR || ''}`}
                    source={amd.EXPIRATION_MESSAGE}
                  />
                )}
              </React.Fragment>
            ))}
            {this.state.showAmendmentMessage && (
              <p className="empty">{this.state.amendmentMessageText}</p>
            )}
          </div>
        ) : (
          <div className="flex-center">
            <Spinner className="page-loader" themeColor="medium-neutral" />
          </div>
        )}
      </div>
    )
  }
}

// const FormDefinitionBlock = ({TITLE, DESCR, FORM_DEFINITION_ID, onClick}) => (
//   <div className='fd-block' onClick={() => {onClick(FORM_DEFINITION_ID)}}>
//     <div className='image-col'>
//       <div className='image'>
//         <div className="img-shade" />
//         <img src={placeholderImg} alt="icon" />
//       </div>
//     </div>
//     <div className='text'>
//       <h4>{TITLE}</h4>
//       <p>{DESCR}</p>
//     </div>
//   </div>
// )
